import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import ComingSoonButton from './ComingSoonButton';
import { useComingSoon } from './ComingSoonProvider';
import logo from '../assets/Keltnine-AI-transparent.png'

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { openModal } = useComingSoon();

  const menuItems = [
    { name: 'Services', href: '#services' },
    { name: 'Solutions', href: '#solutions' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-dark-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <div className="flex items-center space-x-2">
              <img src={logo} alt="Keltnine" className="w-12 h-10" />
              <h1 className="text-2xl font-bold font-display gradient-text">
                Keltnine
              </h1>
            </div>
          </div>

          {/* Desktop Navigation */}
          {/* <nav className="hidden md:flex space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-gray-300 hover:text-white transition-colors duration-200 font-medium"
              >
                {item.name}
              </a>
            ))}
          </nav> */}

          {/* CTA Button */}
          <div className="hidden md:block">
            <ComingSoonButton onClick={openModal} className="px-6 py-2">
              Schedule a Demo
            </ComingSoonButton>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-300 hover:text-white transition-colors duration-200"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-dark-950 rounded-lg mt-2">
              {/* {menuItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block px-3 py-2 text-gray-300 hover:text-white transition-colors duration-200 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))} */}
              <div className="px-3 py-2">
                <ComingSoonButton onClick={openModal} className="w-full">
                  Schedule a Demo
                </ComingSoonButton>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header; 